;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";import { initBugTracking } from "@website/tracking/bug";

initBugTracking({});
